import { localStorageRepositoryFactory } from "@/factories/localStorageRepositoryFactory"

export default {
  get: (name) => localStorageRepositoryFactory.get(name),
}
